import { type PostHogConfig } from 'posthog-js';

export const posthogOptions: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  ui_host: 'https://eu.posthog.com',
  defaults: '2026-01-30',
  autocapture: false,
  capture_pageview: 'history_change',
  capture_pageleave: false,
  disable_session_recording: true,
  remote_config_refresh_interval_ms: 600_000,
};
